
import { observer } from 'mobx-react';

import { useStores } from '@/hooks/use-stores';
import SpinCentered from '@/comp/SpinCentered';

import { FallbackOverviewContainer } from './styled';
import SensorsLogic from './SensorsLogic';
import CompressorsFallback from './CompressorsFallback';
import FallbackTwoPointO from './FallbackTwoPointO';

const FallbackOverview = observer(({ setHasTriedToSubmit, hasTriedToSubmit, fromVersionHistory, versionNumber }) => {
  const { engineStore } = useStores();

  if (engineStore.isLoadingStep) return <SpinCentered />;
  const configurationStatus = engineStore.configurationStatus;
  const showNewFallbackScenarios = engineStore.showNewFallbackScenarios;

  return (
    <FallbackOverviewContainer>
      {showNewFallbackScenarios ? (
        <FallbackTwoPointO 
          configurationStatus={configurationStatus} 
          fromVersionHistory={fromVersionHistory}
          versionNumber={versionNumber}
        />
      ) : (
        <>
          <SensorsLogic 
            setHasTriedToSubmit={setHasTriedToSubmit} 
            hasTriedToSubmit={hasTriedToSubmit}
          />
          <CompressorsFallback 
            setHasTriedToSubmit={setHasTriedToSubmit} 
            hasTriedToSubmit={hasTriedToSubmit}
          />
        </>
      )}

    </FallbackOverviewContainer>
  );
});

export default FallbackOverview;
